import { Component, OnInit } from '@angular/core';
import { fadeInOutAnimation } from '@app/core/animations';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { StepperComponent } from '@app/core/stepper/stepper.component';
import { Store } from '@ngxs/store';
import { AppConfigurationModule } from '../app-configuration.module';
import { PostAppConfigRequest } from '../states/app-configuration.actions';

@Component({
  selector: 'rk-app-content-create',
  templateUrl: './app-content-create.component.html',
  styleUrl: './app-content-create.component.scss',
  imports: [AppConfigurationModule, StepperComponent],
  animations: [fadeInOutAnimation],
})
export class AppContentCreateComponent implements OnInit {
  constructor(private readonly store: Store) {}

  postAppConfig = (): void => {
    this.store.dispatch(new PostAppConfigRequest());
  };

  ngOnInit(): void {
    // event tracking
    this.store.dispatch(
      new SetEventProperties({
        name: 'PageCreationContent',
        component: 'Page',
      }),
    );
    this.store.dispatch(new LogEvent('Page Viewed'));
  }
}
